(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotKfzModel', AngebotKfzModel);

    AngebotKfzModel.$inject = [
        '$http',
        '$q',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'AngebotKfzService',
        'BasisAngebotService',
        'MiscUtilsService',
        'FormatUtilsService',
        'IntegrationService'
    ];
    function AngebotKfzModel($http, $q, _, moment, AppConfig, AngebotModel, AngebotKfzService, BasisAngebotService, MiscUtilsService, FormatUtilsService, IntegrationService) {
        var that = this;

        that.angebotVorbelegen = angebotVorbelegen;
        that.setDefaults = setDefaults;
        that.initAngebotModel = initAngebotModel;

        that.getAngebotErsatzgeschaeftNeu = getAngebotErsatzgeschaeftNeu;
        that.getTarifgenerationUndAngebotErsatzgeschaeftNeu = getTarifgenerationUndAngebotErsatzgeschaeftNeu;
        that.erstelleNeuesAngebotErsatzgeschaeft = erstelleNeuesAngebotErsatzgeschaeft;
        function angebotVorbelegen(angebotModel, defaults) {
            var sfkHaftpflichtKlasseDefault = _.get(defaults, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse.value', _.get(defaults, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht.klasse')),
                sfkVollkaskoKlasseDefault = _.get(defaults, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko.klasse.value', _.get(defaults, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko.klasse')),
                angebotsgegenstandFahrzeugZbn = _.get(defaults, 'angebotsgegenstandFahrzeug.zbn.value', _.get(defaults, 'angebotsgegenstandFahrzeug.zbn')),
                angebotsgegenstandFahrzeugPostleitzahlFahrzeughalter = _.get(defaults, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter.value', _.get(defaults, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter'));
            if (MiscUtilsService.isEmpty(angebotsgegenstandFahrzeugZbn) && MiscUtilsService.isNotEmpty(angebotsgegenstandFahrzeugPostleitzahlFahrzeughalter)) {
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.zbn', null);
            }

            if (MiscUtilsService.isAtLeastOneNotEmpty(sfkHaftpflichtKlasseDefault, sfkVollkaskoKlasseDefault)) {
                AngebotKfzService.getSfkKhKv(angebotModel).then(function (sfKlassen) {
                    if (sfkHaftpflichtKlasseDefault) {
                        _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', _.find(sfKlassen.klassenHaftpflicht, { klasse: sfkHaftpflichtKlasseDefault }));
                    }

                    if (sfkVollkaskoKlasseDefault) {
                        _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.find(sfKlassen.klassenVollkasko, { klasse: sfkVollkaskoKlasseDefault }));
                    }
                });
            }
        }
        function setDefaults(angebot) {
            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                MiscUtilsService.setDefaultValueIfEmpty(angebot, 'angebotsgegenstandFahrzeug.gewerblicheBefoerderung', false);
            }
        }
        function initAngebotModel(angebotModel) {
            angebotModel = angebotModel || {};

            var wkzname = IntegrationService.getIntegrationParams().angwkzname,
                wkz = _.findKey(AppConfig.APP.wkzUrlMapping, function (val) { return val === wkzname; }) || wkzname,
                geburtsdatumAntragsteller = BasisAngebotService.getAngebotspartner(angebotModel.angebot, 'antragsteller').geburtsdatum,
                geburtsdatumJuengsterFahrer = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum'),
                geburtsdatumAeltesterFahrer = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer.geburtsdatum');

            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'angebot.angebotsgegenstandFahrzeug.wkz', {
                typ: 'WKZ',
                wert: wkz
            });

            if (angebotModel.wurdeGeladen || BasisAngebotService.isGevo(angebotModel.angebot, ['KFZ_TARIFUMSTELLUNG'])) {
                if (geburtsdatumAntragsteller && geburtsdatumJuengsterFahrer) {
                    if (AngebotKfzService.getErlaubteTarifmerkmale(angebotModel.angebot).geburtsjahrAeltesterFahrer) {
                        if (
                            geburtsdatumAntragsteller === geburtsdatumJuengsterFahrer &&
                            geburtsdatumAntragsteller === geburtsdatumAeltesterFahrer
                        ) {
                            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', true);
                        } else {
                            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', false);
                        }
                    } else {
                        if (
                            geburtsdatumAntragsteller === geburtsdatumJuengsterFahrer ||
                            (
                                moment(geburtsdatumAntragsteller).year() === moment(geburtsdatumJuengsterFahrer).year() &&
                                moment(geburtsdatumJuengsterFahrer).format('DD.MM.') === '01.01.'
                            )
                        ) {
                            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', true);
                        } else {
                            MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', false);
                        }
                    }
                } else {
                    if (_.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') === _.get(BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotModel.angebot), 'versicherungsnehmer.wert')) {
                        MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', true);
                    } else if (MiscUtilsService.isNotEmpty(_.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'))) {
                        MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.fahrzeugFahrerNurVn', false);
                    }
                }
            }

            if (!BasisAngebotService.isPrivatPerson(angebotModel.angebot)) {
                if ((angebotModel.wurdeGeladen && BasisAngebotService.beitraegeVorhanden(angebotModel.angebot)) || !BasisAngebotService.isAngebotAnonym(angebotModel.angebot)) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.antragsteller.firmenkundeRechtsform', true);
                }
            }

            if (!BasisAngebotService.isGevo(angebotModel.angebot, ['KFZ_TARIFUMSTELLUNG'])) {
                MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.gevoFahrzeugwechsel', false);
                MiscUtilsService.setDefaultValueIfEmpty(angebotModel, 'formData.gevoWeiteresFahrzeug', false);
            }
        }
        function getAngebotErsatzgeschaeftNeu(tarifauskunftsdatum, tarifkuerzel, vertragsnummer) {
            var integrationParameters = IntegrationService.getIntegrationParams();
            return $http({
                method: 'GET',
                url: FormatUtilsService.replace(AppConfig.API.services.angKfzTarifumstellung, tarifkuerzel),
                params: {
                    angebotsdatum: tarifauskunftsdatum,
                    vertragsnummer: vertragsnummer,
                    stichtagTarif: integrationParameters.stichtagTarif
                }
            }).then(function (response) {
                

                return response.data;
            });
        }
        function getTarifgenerationUndAngebotErsatzgeschaeftNeu(tarifauskunftsdatum, vertragsnummer, options) {
            options = options || {};

            options.erzeugeNeuesAngebotImFehlerfall = options.erzeugeNeuesAngebotImFehlerfall !== false;

            return $q(function (resolve, reject) {
                AngebotModel.getTarifgeneration(tarifauskunftsdatum).then(function (data) {
                    getAngebotErsatzgeschaeftNeu(tarifauskunftsdatum, data.tarifkuerzel, vertragsnummer).then(function (angebot) {
                        resolve(AngebotModel.init(angebot));
                    }).catch(function (error) {
                        if (options.erzeugeNeuesAngebotImFehlerfall) {
                            AngebotModel.erstelleNeuesAngebot().then(function (angebotModel) {
                                resolve(angebotModel);
                            }).catch(function (error) {
                                reject(error);
                            });
                        } else {
                            reject(error);
                        }
                    });
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function erstelleNeuesAngebotErsatzgeschaeft(tarifauskunftsdatum, tarif, vertragsnummer, options) {
            return $q(function (resolve, reject) {
                if (!tarif || !tarif.tarifkuerzel) {
                    getTarifgenerationUndAngebotErsatzgeschaeftNeu(tarifauskunftsdatum, vertragsnummer, options).then(function (angebotModel) {
                        if (!angebotModel || !_.isObject(angebotModel)) {
                            return $q.reject();
                        }

                        return resolve(angebotModel);
                    }).catch(function (error) {
                        reject(error);
                    });
                } else {
                    getAngebotErsatzgeschaeftNeu(tarifauskunftsdatum, tarif.tarifkuerzel, vertragsnummer).then(function (angebot) {
                        if (!angebot || !_.isObject(angebot)) {
                            return $q.reject();
                        }

                        return resolve(AngebotModel.init(angebot));
                    }).catch(function (error) {
                        reject(error);
                    });
                }
            });
        }
    }

})();
